import axios from "@/api/axiosInstance";
import { FetchPermissionsForCompanyResponse } from "./types";

export const fetchPermissionsForCompany = async (
  companyUuid: string,
): Promise<FetchPermissionsForCompanyResponse> => {
  const response = await axios.get<FetchPermissionsForCompanyResponse>(
    `/api/private/admin/permissions/by-company/${companyUuid}`,
  );
  return response.data;
};
